import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-listing-one',
  templateUrl: './listing-one.component.html',
  styleUrls: ['./listing-one.component.scss']
})
export class ListingOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
